

@if ({
  row: columnData | async,
  adata: additionData | async
  }; as $) {
  @if (!isEmptyAndNull($.row) && $.row[$.adata.KeyName] && $.row[$.adata.KeyName] !== '01/01/0001 00:00:00') {
    <span>
      {{ getTenantStartDate($.row) }}
    </span>
  } @else {
    -
  }
}
